import { onMounted, onUnmounted } from 'vue';

const DARK_CLASS = 'dark';

// Сколько сейчас смонтировано layout'ов, запросивших тёмную тему. Класс `.dark` держится
// на <html>, пока счётчик > 0.
let darkConsumers = 0;

const syncDarkClass = (): void => {
  document.documentElement.classList.toggle(DARK_CLASS, darkConsumers > 0);
};

/**
 * Держит класс `.dark` на <html>, пока смонтирован хотя бы один layout, запросивший тёмную
 * тему. Reference counting (вместо безусловных `add`/`remove` в каждом layout) переживает
 * пересоздание страницы: при remount ненадолго сосуществуют старый и новый layout, и unmount
 * старого не должен гасить тему, добавленную новым. При любом порядке mount/unmount итог
 * одинаковый — тема остаётся, пока есть хоть один потребитель.
 *
 * Значение `enabled` фиксируется на момент монтирования (darkMode-флаг layout'а статичен).
 */
export function useDarkTheme(enabled = true): void {
  let applied = false;

  onMounted(() => {
    if (!enabled) return;
    darkConsumers += 1;
    applied = true;
    syncDarkClass();
  });

  onUnmounted(() => {
    if (!applied) return;
    darkConsumers -= 1;
    applied = false;
    syncDarkClass();
  });
}
